import {
    MisoPercentageReduction,
    ScenarioAssumptionsCSV,
    ScenarioMetadata
} from "in_queue/types/scenarioType";
import { downloadJSONToCSV } from "utils/csv";
import { emptyScenarioAssumptionsCSV } from "../ScenarioAssumptions";

/** Scenario assumptions that actually resize a project, keyed by project id. */
export const getSizeAdjustments = (
    scenario: ScenarioMetadata
): Record<string, MisoPercentageReduction> => {
    const adjustments: Record<string, MisoPercentageReduction> = {};
    Object.entries(scenario.assumptions).forEach(([projectId, assumption]) => {
        if (assumption.eris !== 0 || assumption.nris !== 0) {
            adjustments[projectId] = assumption;
        }
    });
    return adjustments;
};

/** Download the scenario's size adjustments as a CSV. */
export const downloadSizeAdjustments = (scenario: ScenarioMetadata) => {
    const json = Object.entries(
        getSizeAdjustments(scenario)
    ).map<ScenarioAssumptionsCSV>(([projectId, assumption]) => ({
        project_id: projectId,
        eris_percentage_reduction: assumption.eris,
        nris_percentage_reduction: assumption.nris
    }));

    // Output an empty row when there are no assumptions so the CSV still
    // carries its headers.
    const outputJSON = json.length > 0 ? json : emptyScenarioAssumptionsCSV;

    downloadJSONToCSV({
        json: outputJSON,
        filename: `Nira Export - ${scenario.title} - Scenario Assumptions.csv`
    });
};
